import { FontSize, FontWeight } from 'commons';
import { Heading, Text } from 'components';

interface PageTitleProps {
  title?: string;
  subtitle?: string;
}

export function PageTitle({ title, subtitle }: PageTitleProps) {
  return (
    <div className="flex flex-col gap-2">
      {title && (
        <Heading size={FontSize.font24} weight={FontWeight.bold}>
          {title}
        </Heading>
      )}
      {subtitle && (
        <Text size={FontSize.font16} weight={FontWeight.regular}>
          {subtitle}
        </Text>
      )}
    </div>
  );
}
